module.exports = "https://assets.bwbx.io/s3/reg2/images/google-pay-icon-27dace40cd6debdb70e1.svg";